import styled from 'styled-components';
import { RefreshCw } from 'react-feather';
import { CancelButton } from 'components/ui/Button';

export const StyledCancelButton = styled(CancelButton)`
  > div {
    display: flex;
    align-items: center;
  }
`;

export const StyledRefresh = styled(RefreshCw)`
  margin-right: 7px;
`;
